import { ProductAccessStatus } from 'domain/product/enums';
import { FunctionComponent } from 'react';
import { ButtonContainer } from './styles';
import { ProductAccessButton } from '../Buttons/ProductAccessButton';
import { ProductRegistration } from 'domain/product/interfaces';

interface ProductAccessButtonCellProps {
	productRegistration: ProductRegistration | undefined;
	userId: string;
	onSuccess: (userId: string, newStatus: ProductAccessStatus) => void;
}

export const ProductAccessButtonCell: FunctionComponent<
	ProductAccessButtonCellProps
> = ({ productRegistration, userId, onSuccess }) => (
	<ButtonContainer>
		<ProductAccessButton
			productRegistration={productRegistration}
			onSuccess={onSuccess}
			userId={userId}
		/>
	</ButtonContainer>
);
